export const ACCOUNT_PATH = '/account';
export const LOGIN_PATH = '/account/login';
export const LOGOUT_PATH = '/account/logout';
export const FORGET_PASSWORD_PATH = '/account/forget_password';
export const RESET_PASSWORD_PATH = '/account/reset_password/:token';
export const SETUP_ACCOUNT_PATH = '/account/setup_account/:token';